<style lang="scss" scoped>
</style>

<template>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
        <vForm :label-width="90" :model="formdata" inline>
            <vFormItem label="入库计划单号" class="width-70per margin-left-30" labelWidth="auto" style="width:50%;margin-left:200px"
                        align="right" prop="inboundPlanOrderNo" required>
                <vInput clearable v-model="formdata.inboundPlanOrderNo"></vInput>
            </vFormItem>
            <vFormItem label="入库单号" class="width-70per margin-left-30" labelWidth="auto" style="width:50%;margin-left:200px"
                        align="right" prop="inboundOrderNo" required>
                <vInput clearable v-model="formdata.inboundOrderNo" ></vInput>
            </vFormItem>
            <vFormItem label="入库时间" class="width-70per margin-left-30" prop="stockInAt" labelWidth="auto" style="width:50%;margin-left:200px"
                        align="right" required>
                <vDatepicker type="time" v-model="formdata.stockInAt"></vDatepicker>
            </vFormItem>
            <compUpload
                v-bind="getFileProps"
                @on-close="close"
                @on-success="success"
                style="width:50%;margin-left:200px"
            ></compUpload>
            </vForm>
        </compWrapper>
</template>

<script>
import {
    HttpInboundWinitReceipt
} from "@/service/inbound";
    export default {
        components: {
            compUpload: () => import("@components/templates/upload")
        },
        data() {
            return {
                inboundPlanOrderNo: '',
                inboundOrderNo: '',
                stockInAt: "",
                formdata: {
                    inboundPlanOrderNo: '',
                    inboundOrderNo:'',
                    stockInAt:''
                },
                required: [{
                    required: true,
                    message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
                }],
            }
        },
        computed: {
            getFileProps() {
                return {
                    action: process.env.VUE_APP_APIURL_FBB + '/api/v2/Inbound/inboundWinitReceipt',
                    name: "excelFile",
                    data: {
                        inboundPlanOrderNo: this.formdata.inboundPlanOrderNo,
                        inboundOrderNo:this.formdata.inboundOrderNo,
                        stockInAt:this.formdata.stockInAt
                    },
                    download:()=>{
                        this.handleWebfs("/static/template/cartonList.xlsx", {}, {
                            executor: 'download',
                            type: 'url'
                        });
                        // this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/warehouseStorage/warehouseStorageTemplate", {}, 'download')
                    }
                }
		    },
        },
        methods: {
            success(res) {
                // console.log(343434343)
                this.$VMessage.success(res.message);
                this.close();
            },
            close() {
                // console.log(5656565656)
                this.$emit('on-close');
            }
        }
    }
</script>
